import http from '../../rest/http';
    

export const fetchStaffCountService = async () => {
  try {
    const response = await http.get(`/api/v1/user/counts`);
    return response;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
